<script lang="ts">
  import { addDays, format, isToday } from 'date-fns';
  import TodayTimelineView from '../Today/TodayTimelineView.svelte';
  import TodayGroupedByTypeView from '../Today/TodayGroupedByTypeView.svelte';
  import { Button } from '@/lib/components/ui/button';
  import type { TodaysActivities } from '@/Common/constants';
  import { formatFriendlyDatePossesive } from '@/Util/utils';
  import { XfaiBall } from '@/Common';
  import AdaptForecastDialog from '../Calendar/AdaptForecastDialog.svelte';

  export let todaysActivities: TodaysActivities;
  export let currentDay: Date;
  export let isResyncing: boolean;
  export let conflictNotes: string[] = [];
  export let onDateChange: (newDate: Date) => void;
  // The Adapt Forecast button, for a screen too narrow for the Next 3 days column that has it. The page passes these when the athlete has a forecast plan.
  export let showAdapt = false;
  export let isForecastUpToDate = true;
  export let lastForecastInputs: any = null;
  let adaptForecastModal;
  let selectedTab: 'grouped' | 'timeline' = 'grouped';

  let activityImageCarouselNumber: Record<string, number> = {}

</script>

<div>
  <div class="w-full">
    <div class='flex flex-row w-full gap-2'>
      <div class="flex flex-row gap-2 items-center flex-wrap">
        <Button variant="outline" size="sm" class="shrink-0" disabled={isToday(currentDay)} on:click={() => onDateChange(new Date())}>Today</Button>
        <Button variant="ghost" size="sm" class="px-2 shrink-0" on:click={() => onDateChange(addDays(currentDay, -1))}>
          <i class='fa-thin fa-xl fa-chevron-left' aria-hidden='true'/>
        </Button>
        <Button variant="ghost" size="sm" class="px-2 shrink-0" on:click={() => onDateChange(addDays(currentDay, 1))}>
          <i class='fa-thin fa-xl fa-chevron-right' aria-hidden='true'/>
        </Button>
        <h1 class="text-2xl font-semibold m-0 capitalize min-w-0">{formatFriendlyDatePossesive(currentDay)} Activities</h1>
        {#if isResyncing}
          <i class='fa-solid fa-lg fa-spinner-third fa-spin shrink-0' title="Resyncing..."></i>
        {/if}
      </div>
      <div class="flex-1" />
      {#if showAdapt}
        <Button variant="outline" size="sm" class="shrink-0 lg:hidden group/crysball inline-flex justify-center items-center" id="adapt-forecast-btn-mobile"
          title={!isForecastUpToDate ? 'Your availabilities have changed, click here to adapt your forecast' : 'Click here to adapt your forecast to any new preferences'}
          on:click={() => adaptForecastModal.openModal()}>
          <span class="relative px-[2px] pt-1 mr-1">
            <XfaiBall class="h-5" type="hover" />
            {#if !isForecastUpToDate}<span class="absolute top-0.5 right-0.5 h-2 w-2 rounded-full bg-red-600" aria-hidden="true" />{/if}
          </span>
          <span>Adapt Forecast</span>
        </Button>
      {/if}
      {#if selectedTab === 'grouped'}
        <Button variant="outline" size="sm" class="shrink-0" on:click={() => (selectedTab = 'timeline')}>Timeline</Button>
      {:else}
        <Button variant="outline" size="sm" class="shrink-0" on:click={() => (selectedTab = 'grouped')}>Groups</Button>
      {/if}
    </div>
  </div>

  {#if showAdapt}
    <AdaptForecastDialog bind:this={adaptForecastModal} forecastData={lastForecastInputs} today={new Date()} />
  {/if}

  {#if selectedTab === 'grouped'}
    <TodayGroupedByTypeView {todaysActivities} bind:activityImageCarouselNumber {conflictNotes} />
  {:else}
    <TodayTimelineView {todaysActivities} bind:activityImageCarouselNumber {conflictNotes} />
  {/if}
</div>
